export default {
  mytopic_my_reply: '我的回帖',
  mytopic_my_collect: '我的收藏',
  mytopic_post_manage: '我下架的帖子',
  mytopic_comment_manage: '我下架的评论和回复',
  mytopic_cancel_collect: '取消收藏',
  mytopic_comfirm_collect: '确认取消收藏?',
  mytopic_restore_success: '恢复上架成功',
  mytopic_restore_failed: '恢复上架失败',
  mytopic_resume: "恢复上架",
  mytopic_confirm_resume: "确认恢复上架吗？",
  mytopic_make_comment: '评论:',
  mytopic_make_collect: '收藏:',
  mytopic_make_like: '点赞：',
  mytopic_del_failed: '删除失败',
  mytopic_confirm_del_now: '确认立即删除？',
  mytopic_del_success: '删除成功',
}
